// extracted by mini-css-extract-plugin
module.exports = {"card":"ProductCarousel_card__2U2kW","sticker":"ProductCarousel_sticker__80MQc","shortLabel":"ProductCarousel_shortLabel__1-YpK"};